<div class="p-30 cookies-config-modal">
  <header>
    <h1>
      Configurar cookies
    </h1>

    <span>X</span>
  </header>



  <footer>

  </footer>
</div>
